const getThreadParentId = (threadMeta) => {
  return String(threadMeta?.parentThreadId || threadMeta?.parent_thread_id || threadMeta?.parent?.threadId || threadMeta?.parent?.id || '').trim() || null;
};

export default getThreadParentId;
